import { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';

const CHEAT_SHEET = [
  { syntax: '# Titlu mare', result: 'Titlu mare (h1)' },
  { syntax: '## Subtitlu', result: 'Subtitlu (h2)' },
  { syntax: '### Secțiune', result: 'Secțiune (h3)' },
  { syntax: '**text bold**', result: 'text bold' },
  { syntax: '*text italic*', result: 'text italic' },
  { syntax: '[text](https://...)', result: 'Link către URL' },
  { syntax: '- element', result: 'Listă neordonată' },
  { syntax: '1. element', result: 'Listă ordonată' },
  { syntax: '---', result: 'Linie de separare' },
  { syntax: 'Linie 1  \\nLinie 2', result: 'Rând nou (două spații la final)' },
];

export function MarkdownHelpButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex h-5 w-5 items-center justify-center rounded-full border text-muted-foreground hover:border-[var(--vivid-purple)] hover:text-[var(--vivid-purple)]"
        title="Ghid formatare Markdown"
      >
        <HelpCircle className="h-3.5 w-3.5" />
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => setOpen(false)}>
          <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-xl" onClick={(e) => e.stopPropagation()}>
            <div className="mb-4 flex items-center justify-between">
              <h3 className="text-lg font-bold" style={{ fontFamily: 'var(--font-primary)' }}>
                Formatare Markdown
              </h3>
              <button onClick={() => setOpen(false)} className="rounded-lg p-1 text-muted-foreground hover:bg-gray-100">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="overflow-hidden rounded-lg border">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b bg-gray-50">
                    <th className="px-3 py-2 text-left font-medium" style={{ fontFamily: 'var(--font-primary)' }}>Scrii</th>
                    <th className="px-3 py-2 text-left font-medium" style={{ fontFamily: 'var(--font-primary)' }}>Obții</th>
                  </tr>
                </thead>
                <tbody style={{ fontFamily: 'var(--font-secondary)' }}>
                  {CHEAT_SHEET.map((row, i) => (
                    <tr key={i} className="border-b last:border-b-0">
                      <td className="px-3 py-1.5">
                        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-xs">{row.syntax}</code>
                      </td>
                      <td className="px-3 py-1.5 text-xs text-muted-foreground">{row.result}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
